import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface NotificationState {
  isOpen?: boolean;
  type: 'success' | 'error' | 'info';
  title: string;
  description?: string;
  duration?: number;
}

const initialState: NotificationState = {
  isOpen: false,
  type: 'success',
  title: '',
  description: '',
  duration: 3000,
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    openNotification: (state, action: PayloadAction<NotificationState>) => {
      state.isOpen = true;
      state.title = action.payload.title;
      state.description = action.payload.description;
      state.type = action.payload.type;
    },
    closeNotification: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openNotification, closeNotification } =
  notificationSlice.actions;
